import { useState } from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";


export default function CheckboxesGroup() {
  const [singlState] = useState({
    firstName: true,
    lastName: true,
    email: true,
    medicalLicense: true,
    telephone: true,
    city: true,
    speciality: true,
    nationalID: true,
    organization: true,
  });


  return (
    <Box sx={{ display: "flex" }}>
      <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox checked={singlState.nationalID} name={`nationalID`} />
            }
            label={`National ID`}
          />
          <FormControlLabel
            control={<Checkbox checked={singlState.firstName} name={`firstName`} />}
            label={`First Name`}
          />
          <FormControlLabel
            control={<Checkbox checked={singlState.lastName} name={`lastName`} />}
            label={`Last Name`}
          />
          <FormControlLabel
            control={<Checkbox checked={singlState.email} name={`email`} />}
            label={`Email`}
          />
          <FormControlLabel
            control={
              <Checkbox checked={singlState.telephone} name={`telephone`} />
            }
            label={`Phone Number`}
          />
          <FormControlLabel
            control={
              <Checkbox checked={singlState.speciality} name={`speciality`} />
            }
            label={`Speciality`}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={singlState.organization}
                name={`organization`}
              />
            }
            label={`Organization`}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={singlState.medicalLicense}
                name={`medicalLicense`}
              />
            }
            label={`Medical License ID`}
          />
          <FormControlLabel
            control={<Checkbox checked={singlState.city} name={`city`} />}
            label={`City`}
          />
        </FormGroup>
      </FormControl>
    </Box>
  );
}
